import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "热门主角", to: "/renwu" },
  { label: "走红大事记", to: "/shijian" },
  { label: "关于我们", to: "/about" },
];

function navClass({ isActive }: { isActive: boolean }) {
  return `relative whitespace-nowrap px-1 py-1 font-label text-sm transition-colors ${
    isActive ? "text-foreground-950 font-medium" : "text-foreground-600 hover:text-foreground-950"
  }`;
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSubscribe = () => {
    setOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
      }, 80);
    } else {
      document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b border-background-200 transition-colors ${
        scrolled ? "bg-background-50/95 backdrop-blur" : "bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between md:h-20">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label="吃瓜爆网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">吃瓜爆网</span>
            <span className="mt-1 text-[10px] font-label tracking-[0.2em] text-foreground-500 uppercase">
              爆红人物追踪档案
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} className={navClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button type="button" onClick={goSubscribe} className="btn-primary cursor-pointer">
            <i className="ri-mail-add-line" aria-hidden="true" />
            订阅资讯
          </button>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden cursor-pointer"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-2.5 font-label text-[15px] ${
                    isActive ? "bg-primary-100/70 text-primary-700 font-medium" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <button type="button" onClick={goSubscribe} className="btn-primary mt-2 cursor-pointer">
              <i className="ri-mail-add-line" aria-hidden="true" />
              订阅资讯
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}